/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgAccountAnalyticsLogo = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.01 2.01l.5-.5h4.98l.353.146h.002l.1.102 3.908 3.888L13 6v2h-1V6.52H8.49l-.5-.5V2.51H4.01v11H7v1H3.51l-.5-.5v-12zm5.98 1.212V5.52h2.282L8.99 3.222z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 14.5V9h-1v5.5h1zM11 14.5v-4.125h-1V14.5h1zM9 14.5v-2.063H8V14.5h1z"
}));

export default SvgAccountAnalyticsLogo;